import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import './styles/element-variables.scss'
import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import '@/filters'

import '@/icons' // icon
import '@/permission' // permission control

import OssImage from './components/OssImage/index.vue'

import RageTitle from '@/components/PageTitle'
import Debug from '@/components/Debug'

Vue.use(ElementUI, { locale })

Vue.component('page-title', RageTitle)
Vue.component('debug', Debug)
Vue.prototype.$ossImageUrl = (image, styleName) => {
  if (image && image.startsWith('/')) {
    let src = `${process.env.VUE_APP_OSS_HOST}${image}`
    if (styleName) {
      src += `?x-oss-process=style/${styleName}`
    }
    return src
  }
  return image
}
Vue.component('OssImage', OssImage)

Vue.config.productionTip = false

Vue.prototype.$contentBoxScrollTop = {
  set(y) {
    const scrollContainer = window.document.querySelector('.main-container')
    if (scrollContainer) {
      scrollContainer.scrollTop = y
    }
  },
  get() {
    const scrollContainer = window.document.querySelector('.main-container')
    return scrollContainer ? scrollContainer.scrollTop : 0
  }
}

router.afterEach((to, from) => {
  Vue.prototype.$contentBoxScrollTop.set(0)
  if (to.name) {
    window.document.querySelector('body').className = 'page-' + to.name
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
